import React, { PureComponent } from 'react';
import { HomeNews, NextServices } from '../index';
import classnames from 'classnames';
import PhotoHomeNews from '../../assets/img/home-news.jpg';
import Patagonia from '../../assets/img/last/patagonia/8.jpg';

class SummaryGroup extends PureComponent {

  getClass(size) {
    const classNames = {};

    switch (size) {
      case 1:
        classNames['col-md-3'] = true;
        break;
      case 2:
        classNames['col-md-6'] = true;
        break;
      case 3:
        classNames['col-md-9'] = true;
        break;
      default:
        classNames['col-md-12'] = true;
    }
    return classNames;
  }


  getClass2(size) {
    const classNames = {};

    switch (size) {
      case 4:
        classNames['col-md-3'] = true;
        break;
      case 2:
        classNames['col-md-6'] = true;
        break;
      case 3:
        classNames['col-md-4'] = true;
        break;
      default:
        classNames['col-md-12'] = true;
    }
    return classNames;
  }

  setTypes = () => {
    const { lastNews, articles } = this.props;
    lastNews.map((obj) => {
      obj.type = 'last-event';
    });

    articles.map((obj) => {
      obj.type = 'news';
    })
  };

  render() {
    this.setTypes();
    // const { info } = this.state;
    const { lastNews, articles } = this.props;

    const info = [
      {
        title: 'Últimos eventos',
        list: lastNews
      },
      {
        title: 'Notícias',
        list: articles
      }];
    return (
      <div className="container summary-group">
        <div className="row">
          {
            info.map((infoObj, infoIndex) => {
              const className = classnames(this.getClass(infoObj.list.length));
              return (
                <div className={className} key={infoIndex}>
                  <h2 className="summary-group__title">{infoObj.title}</h2>
                  <div className="row summary-group__items">
                    {
                      infoObj.list.map((valueObj) => {
                        const classNames = classnames(this.getClass2(infoObj.list.length));
                        return (
                          <div key={valueObj.id} className={classNames}>
                            {valueObj.type === 'news' ? <HomeNews {...valueObj}/> : <NextServices {...valueObj}/>}
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

SummaryGroup.propTypes = {};
SummaryGroup.defaultProps = {};

export default SummaryGroup;



// WEBPACK FOOTER //
// ./src/components/summary-group/SummaryGroup.js